import { render, staticRenderFns } from "./SubCategoryListItem.vue?vue&type=template&id=9234dca4&scoped=true"
import script from "./SubCategoryListItem.vue?vue&type=script&lang=js"
export * from "./SubCategoryListItem.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryListItem.vue?vue&type=style&index=0&id=9234dca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9234dca4",
  null
  
)

export default component.exports